<script lang="ts">
  import Checkbox from "../input/CheckboxInput.svelte";
  import type { FacetValue, FacetValueOptions } from "./type.ts";
  import { MultiSelect } from "../facet-value-input";
  import { Text } from "../facet-value-label";

  interface Props extends FacetValue, FacetValueOptions {}

  let { input = checkbox, children = text, ...rest }: Props = $props();
</script>

{#snippet checkbox()}
  <MultiSelect {...rest} />
{/snippet}

{#snippet text()}
  <Text size="125" {...rest} />
{/snippet}

<Checkbox class="hc_facetValue" fitContent labelPlacement="right" {input} {children} />
